var utils = require('../../../utils')

export default {
  name: 'shop-user-list',
  created () {
    var readMore = false
    if (this.currentPage !== null && this.currentPage >= 1) {
      readMore = 'keepload'
    }
    this.shopId = this.$route.params.id

    utils.backClear()

    this.search()
    // 最下部スクロール検索イベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  data () {
    return {
      shopId: null,
      searchCallbackFlag: false,
      sortKey: '',
      sortStateOrder: '',
      sortState: {
        'login_id':       {'state': true,  'order': true},
        'user_name':      {'state': false, 'order': false},
        'shop_name':      {'state': false, 'order': false},
        'age':            {'state': false, 'order': false},
        'user_type_name': {'state': false, 'order': false},
        'join_date':      {'state': false, 'order': false}
      }
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロール検索イベント削除
    next()
  },
  computed: {
    loading () {
      return this.$store.getters.shopUserListLoading
    },
    users () {
      return this.$store.getters.shopUserListUsersData
    },
    nextPage () {
      return this.$store.getters.shopUserListNextPage
    },
    currentPage () {
      return this.$store.getters.shopUserListCurrentPage
    },
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    isSystemManagement () {
      return this.$store.getters.isSystemManagement
    },
    timeStamp() {
      var d = new Date()
      var year  = d.getFullYear()
      var month = d.getMonth() + 1
      var day   = d.getDate()
      var hour  = (d.getHours() < 10) ? '0' + d.getHours()   : d.getHours()
      var min   = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec   = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year +''+ month +''+ day +''+ hour +''+ min +''+ sec
    }
  },
  methods: {
    search: function(readMore) {
      var url = null
      if (readMore) {
        url = this.$store.getters.shopUserListNextPage
      } else {
        this.searchCallbackFlag = false
      }
      var self = this
      var callback = function (){
        self.searchCallbackFlag = true
      }
      var data = { 'shop_id': this.$route.params.id,
                   'order':   this.orderByString(),
      }
      if (readMore === 'sort' || readMore === 'keepload') {
        // ソート、再読込 現在のページを指定
        data['current_page'] = this.currentPage
      } else {
        data['current_page'] = null
      }
      this.$store.dispatch('SHOP_USER_LIST',  {url: url, data: data, callback: callback})
    },
    sortBy: function(key) {
      this.sortKey = key
      this.sortStateOrder = !this.sortState[key].order
      for (var k in this.sortState) {
        this.sortState[k].state = false
        if (k !== key) {
          this.sortState[k].order = false
        }
      }
      this.sortState[key].state = true
      this.sortState[key].order = !this.sortState[key].order
      // 検索
      this.search('sort')
    },
    getArrow: function(key) {
      var state = this.sortState[key].state ? ' color-light-blue' : ''
      var arrow = this.sortState[key].order ? 'fa-arrow-up' : 'fa-arrow-down'
      return arrow + state
    },
    /** ソート文字列取得 */
    orderByString: function() {
      var result = []
      for (var key in this.sortState) {
        if (this.sortState[key].state) {
          var asc_desc = 'asc'
          if (!this.sortState[key].order) {
            asc_desc = 'desc'
          }
          result.push(key + ' ' + asc_desc)
        }
      }
      if (result.length <= 0) {
        // 存在しない場合
        result.push('login_id asc')
      }
      return result.join(' , ')
    },
    goUserLists: function() {
      utils.backClear()
      this.$router.push({ path: '/users', query: { type: this.$router.currentRoute.query.type}})
    },
    goShopLists: function() {
      utils.backClear()
      this.$router.push({ path: '/shops', query: { type: this.$router.currentRoute.query.type}})
    },
    goShopDetail: function() {
      utils.backClear()
      this.$router.push({ path: '/shops/' + this.shopId, query: { type: this.$router.currentRoute.query.type}})
    },
    goUserDetail: function (userId) {
      window.sessionStorage.setItem('BackPage', '/shops/'+ this.shopId + '/users/')
      this.$router.push({ path: '/users/' + userId })
    },
    /** 画像押下 */
    onClickImageModalShow: function (user) {
      var button = document.getElementById('imageModalButton')
      var img = document.getElementById('imageModalImg')
      var text = document.getElementById('imageModalText')
      img.src = user.attributes['avartar-path'] + '?token=' + this.authToken + "&timestamp=" + self.timeStamp

      text.textContent = ''
      button.click() // モーダル表示 イベント発火
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/shop/user-list.js